var map = {
	"./cloud1.webp": "4529",
	"./cloud2.webp": "faa5",
	"./cloud3.webp": "47b7",
	"./cloud4.webp": "e1cd",
	"./cloud5.webp": "45a6",
	"./cloud6.webp": "f9a9",
	"./cloud7.webp": "fd45"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e4d1";